import { ComponentProps } from 'react';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import Table from 'antd/es/table';
import clsx from 'clsx';
import { tableStateKeys } from './constants/tableStateKeys';
import { type OpTableRecordType } from './types';

import './OpTableCore.scss';

export type OpTableCorePropsType<RecordType extends OpTableRecordType> =
  ComponentProps<typeof Table<RecordType>> & {
    loading?: boolean;
    testId?: string;
    gtm?: string;
    // Unique key used in the uiState table as uiComponentKey
    uiStateKey: Utils.ValueOf<typeof tableStateKeys>;
  };

export const OpTableCore = <RecordType extends OpTableRecordType>({
  className,
  loading = false,
  testId = 'op-table-core',
  gtm,
  uiStateKey,
  ...tableProps
}: OpTableCorePropsType<RecordType>) => {
  /**
   * Manually throwing an error here incase this table is used in a non Typescript file
   * Realistically this will never happen. Currently we have no case of this occurring so its safe. Any new
   * code will catch this in development thus throwing is just very blatant for the dev.
   */
  if (!uiStateKey) {
    throw new Error('uiStateKey prop is required');
  }

  return (
    <Table
      data-testid={testId}
      data-gtm={gtm}
      className={clsx('op-table-core', className)}
      size="middle"
      loading={{
        spinning: loading,
        indicator: <LoadingOutlined data-testid={'op-table-loader'} />,
      }}
      {...tableProps}
    />
  );
};
